import { render, staticRenderFns } from "./Bedarfsmedikation.vue?vue&type=template&id=d44e3a24&"
import script from "./Bedarfsmedikation.vue?vue&type=script&lang=js&"
export * from "./Bedarfsmedikation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports